// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-5211b6db3357ebfb.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 19) return "static/chunks/19-1f939d587444f697.js";
	if (chunkId === 8765) return "static/chunks/8765-73b335754a094ef9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"001d129ecb2e2abe","1694":"ad054400c4a6aefb","6793":"f57464ca23fa9330","6799":"7fde3a760e86ce50","8933":"1349b098e4bc7367"}[chunkId] + ".js";
};